import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';

import { ApolloClient, ApolloProvider, createNetworkInterface } from 'react-apollo';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import ru from 'react-intl/locale-data/ru';
import * as messages from './translations';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { lightBlue900, indigoA200 } from 'material-ui/styles/colors';

import DocumentTitle from 'react-document-title';

import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContextProvider } from 'react-dnd';

import config from './config';
import './index.css';
import App from './App';

const muiTheme = getMuiTheme({
    palette: {
        primary1Color: lightBlue900,
        accent1Color: indigoA200,
    },
});

const apolloClient = new ApolloClient({
    networkInterface: createNetworkInterface({
        uri: `${config.backend}/graphql`,
        opts: {
            credentials: 'include',
        },
    }),
});

const intlPromise = global.Intl
    ? Promise.resolve()
    : Promise.all([import('intl'), import('intl/locale-data/jsonp/en.js'), import('intl/locale-data/jsonp/ru.js')]);

intlPromise.then(() => {
    addLocaleData([...en, ...ru]);

    const locale =
        ((navigator.language && navigator.language.indexOf('ru') !== -1) ||
            (navigator.languages && navigator.languages.find(language => language.indexOf('ru') !== -1)) ||
            document.location.pathname.startsWith('/report/ru')) &&
        !document.location.pathname.startsWith('/report/en')
            ? 'ru'
            : 'en';

    ReactDOM.render(
        <ApolloProvider client={apolloClient}>
            <MuiThemeProvider muiTheme={muiTheme}>
                <IntlProvider locale={locale} messages={messages[locale]}>
                    <DocumentTitle title={messages[locale].title}>
                        <BrowserRouter>
                            <DragDropContextProvider backend={HTML5Backend}>
                                <App />
                            </DragDropContextProvider>
                        </BrowserRouter>
                    </DocumentTitle>
                </IntlProvider>
            </MuiThemeProvider>
        </ApolloProvider>,
        document.getElementById('root')
    );
});



// WEBPACK FOOTER //
// ./src/index.js